module.exports = __webpack_public_path__ + "static/Grupo225-26287e9446c3adc4d214cb7ece0cc1e7.png";